import { render, staticRenderFns } from "./association-management.vue?vue&type=template&id=209b2e0e&scoped=true&"
import script from "./association-management.vue?vue&type=script&lang=js&"
export * from "./association-management.vue?vue&type=script&lang=js&"
import style0 from "./association-management.vue?vue&type=style&index=0&id=209b2e0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b2e0e",
  null
  
)

export default component.exports